import sauna from '@/assets/img/users-cases/sauna.webp';
import saunaHow from '@/assets/img/users-cases/sauna-how.webp';
import saunaResult from '@/assets/img/users-cases/sauna-result.webp';

export default {
  slug: 'sauna',
  order: 19,
  title: '3D Sauna & Spa Tour',
  subtitle: 'Spa layouts with warm 3D renderings and details',
  tags: ['Saunalayouts', 'InteriorDesign'],

  images: {
    hero: sauna,
    aboutTop: saunaHow,
    aboutBottom: saunaResult,
  },

  howText:
    'We worked out 2D and 3D sauna floor plans and interior design, taking into account operational requirements and presentation goals.',

  resultText:
    'The final materials are used in commercial proposals and investor pitch decks.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
